export const ActionTypes = {
  OPEN_MODAL: 'MODALS/OPEN_MODAL',
  CLOSE_MODAL: 'MODALS/CLOSE_MODAL',
  SET_MODAL_DATA: 'MODALS/SET_DATA',
  UNLOCK_ACTIVITY_COMPLETED: 'MODALS/UNLOCK_ACTIVITY_COMPLETED',
} as const

export const CREATE_PROJECT_MODAL = 'create-project'
export const CREATE_FOLDER_MODAL = 'create-folder'
export const DELETE_MODAL = 'delete'
export const DELETE_PROJECT_MODAL = 'delete-project'
export const EDIT_PROJECT_MODAL = 'edit-project'
export const EDIT_FOLDER_MODAL = 'edit-folder'
export const MOVE_PROJECT_MODAL = 'move-project'
export const COPY_SUCCESS_MODAL = 'copy-success'
export const COPY_SUCCESS_INTERSTITIAL_MODAL = 'copy-success-interstitial-modal'
export const SUPER_AUTH_IFRAME_MODAL = 'super-auth-iframe-modal'
export const ONE_AUTH_MODAL = 'one-auth-modal'
export const VALUE_EXCHANGE_MODAL = 'value-exchange-modal'
export const REDESIGNED_UNLOCK_MODAL = 'redesigned-unlock-modal'
// viewpage
export const PREMIUM_COPY_MODAL = 'premium-copy'
export const GOOGLE_DOC_MODAL = 'google-doc'
export const EXPORT_MODAL = 'export'
export const GATED_BIBLIOGRAPHY_ON_CITATION_COUNT_MODAL =
  'gated-bibliography-on-citation-count'
export const GATED_EXPORT_MODAL = 'gated-export-modal'
export const GATED_BIBLIOGRAPHY_ON_EXPIRATION_MODAL = 'gated-bibliography-on-expiration'
export const GATED_IN_TEXT_CITATION_MODAL = 'gated-in-test-citation-modal'
export const UNLOCK_ACCOUNT_GATE_MODAL = 'unlock-account-gate-modal'
export const CHANGE_TO_FREE_STYLE_MODAL = 'change-to-free-style-modal'
export const PLAGIARISM_SCROLL_MODAL = 'plagiarism-scroll-modal'
export const DISCOUNT_MODAL = 'discount-modal'
export const UPGRADE_MODAL = 'upgrade-modal'
export const NEW_CITATION_LIST_MODAL = 'new-citation-list-modal'
